import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import AccountStatements from "../components/AccountStatements";
import Benefits from "../components/Benefits/Benefits";
import Calculators from "../components/Calculators/Calculators";
import CrecerMas from "../components/CrecerMas";
import Constants from "../utils/constants";
import Dashboard from "../components/Dashboard";
import DistributionFunds from "../components/DistributionFunds";
import Login from "../components/Login";
import NotFound from "../components/NotFound";
import Profile from "../components/Profile/Profile";
import React from "react";
import BenefitsRequestsClaims from "../components/BenefitsRequestsClaims/BenefitsRequestsClaims";
import SignUp from "../components/SignUp";
import RecoverPassword from "../components/RecoverPassword";
import PublicAccountStatements from "../components/Public/PublicAccountStatements";
import PublicCalculators from "../components/Public/PublicCalculators";
import PrivateRoute from "../security/PrivateRoute";
import ResetPassword from "../components/ResetPassword";
import PublicJob from "../components/Public/PublicJobs";
import PublicSMS from "../components/Public/PublicSMS";
import { BpmsTask } from "../components/Bpms/BpmsTasks";
import PublicSMSGUID from "../components/Public/PublicSMSGUID";
import DevTools from "../components/DevTools/DevTools";

const Pages = () => {
  return (
    <Router basename={'/ofv'}>
      <Routes>
        <Route path={Constants.APPURLS.LOGIN} element={<Login />} />
        <Route path={Constants.APPURLS.SIGNUP} element={<SignUp />} />
        <Route path={Constants.APPURLS.RECOVER_PASSWORD} element={<RecoverPassword />} />
        <Route path={Constants.APPURLS.RESET_PASSWORD} element={<ResetPassword />} />
        <Route path={Constants.APPURLS.CALCULATORS} element={<Calculators />} />
        <Route path={Constants.APPURLS.PUBLIC_JOB} element={<PublicJob />} />
        <Route path={Constants.APPURLS.PUBLIC_CALCULATORS} element={<PublicCalculators />} />
        <Route path={Constants.APPURLS.PUBLIC_ACCOUNT_STATEMENTS} element={<PublicAccountStatements />} />
        <Route path={Constants.APPURLS.PUBLIC_SMS} element={<PublicSMS />} />
        <Route path={Constants.APPURLS.PUBLIC_SMS_GUID} element={<PublicSMSGUID />} />
        <Route path={Constants.APPURLS.DEVTOOLS} element={<DevTools />} />
        <Route path="*" element={<NotFound />} />

        <Route path={Constants.APPURLS.DASHBOARD} element={<PrivateRoute />}>
          <Route path="" element={<Dashboard />} />
          <Route path={Constants.APPURLS.ACCOUNT_STATEMENTS} element={<AccountStatements />} />
          <Route path={Constants.APPURLS.DISTRIBUTION_FUNDS} element={<DistributionFunds />} />
          <Route path={Constants.APPURLS.REQUESTS_SERVICES_CLAIMS} element={<BenefitsRequestsClaims />} />
          <Route path={Constants.APPURLS.BENEFITS} element={<Benefits />} />
          <Route path={Constants.APPURLS.CRECER_MAS} element={<CrecerMas />} />
          <Route path={Constants.APPURLS.BPMS_TASK} element={<BpmsTask />} />
          <Route path={Constants.APPURLS.PROFILE} element={<Profile />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default Pages;
